<template>
  <div style="padding: 10px 20px;min-height: calc(100vh - 168px);" class="recommendSet">
    <el-collapse accordion @change="handleChangeEvent">
      <el-collapse-item name="news">
        <template slot="title">
          <span class="set_title">推荐新闻: </span>
          <span class="setting-item type"
                :type="settings.news.settingType">推荐方式: {{ settings.news.settingType | typeFmt }}</span>
          <span class="setting-item">数量限制: {{ settings.news.numLimit }}</span>
          <i class="el-icon-setting" @click="updateSetting('news','新闻')"></i>
        </template>
        <div class="list">
          <div class="detail" v-for="item in settingItems.news" :key="item.id">
            <h3 class="tit">{{ item.title }}</h3>
            <div class="time flex">
              <div class="flex"><span class="line"></span><span class="dot"></span><span
                  class="dot"></span>{{ item.publishDate }}
              </div>
              <router-link :to="'/newsDetail?id='+item.id" class="more">了解详情</router-link>
            </div>
            <p class="content">{{ item.summary }}</p>
          </div>
        </div>
      </el-collapse-item>

      <el-collapse-item name="doctor">
        <template slot="title">
          <span class="set_title">推荐医生: </span>
          <span class="setting-item type"
                :type="settings.doctor.settingType">推荐方式: {{ settings.doctor.settingType | typeFmt }}</span>
          <span class="setting-item">数量限制: {{ settings.doctor.numLimit }}</span>
          <i class="el-icon-setting" @click="updateSetting('doctor','医生')"></i>
        </template>
        <div>
          <div class="doctor_item" :style="'backgroundImage: url('+item.headImgPath+')'"
               v-for="item in settingItems.doctor" :key="item.id">
            <div class="title">{{ item.fullName }}</div>
            <div><span class="sub_title">擅长病种：</span>{{ item.indications | indicationFmt }}</div>
          </div>
        </div>
      </el-collapse-item>

      <el-collapse-item name="research">
        <template slot="title">
          <span class="set_title">推荐研究: </span>
          <span class="setting-item type"
                :type="settings.research.settingType">推荐方式: {{ settings.research.settingType | typeFmt }}</span>
          <span class="setting-item">数量限制: {{ settings.research.numLimit }}</span>
          <i class="el-icon-setting" @click="updateSetting('research','研究')"></i>
        </template>
        <div>
          <div class="research_item" :style="'backgroundImage: url('+item.thumbnailPath+')'"
               v-for="item in settingItems.research" :key="item.id">
            <div>
              <div class="title">{{ item.title }}</div>
              <div class="summary">{{ item.summary }}</div>
              <router-link :to="'/studyDetail?id='+item.id" class="flex">READ MORE</router-link>
            </div>
          </div>
        </div>
      </el-collapse-item>


      <el-collapse-item name="drug">
        <template slot="title">
          <span class="set_title">推荐药物: </span>
          <span class="setting-item type"
                :type="settings.drug.settingType">推荐方式: {{ settings.drug.settingType | typeFmt }}</span>
          <span class="setting-item">数量限制: {{ settings.drug.numLimit }}</span>
          <i class="el-icon-setting" @click="updateSetting('drug','药物')"></i>
        </template>
        <div>
          <div class="drug_item" :style="'backgroundImage: url('+item.thumbnailPath+')'"
               v-for="item in settingItems.drug" :key="item.id">
            <div class="mask">
              <div class="title">{{ item.cnName }}</div>
              <div class="desc">{{ item.briefDesc }}</div>
              <div>
                <el-button>
                  <router-link :to="'/medicationDetail?id='+item.id">了解详情</router-link>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>

      <el-collapse-item name="consultation">
        <template slot="title">
          <span class="set_title">推荐会诊: </span>
          <span class="setting-item type"
                :type="settings.consultation.settingType">推荐方式: {{ settings.consultation.settingType | typeFmt }}</span>
          <span class="setting-item">数量限制: {{ settings.consultation.numLimit }}</span>
          <i class="el-icon-setting" @click="updateSetting('consultation','会诊')"></i>
        </template>
        <div>
          <div class="con_item thumb"
               :style="'backgroundImage: url('+settingItems.consultation.thumbnailPath+')'"></div>
          <div class="con_item content">
            <div class="title">{{ settingItems.consultation.title }}</div>
            <div class="sub_title">{{ settingItems.consultation.subTitle }}</div>
            <div>
              <el-button type="warning" plain>
                <router-link :to="'/consultationDetail?state=0&id='+settingItems.consultation.id">详情</router-link>
              </el-button>
            </div>
          </div>
        </div>
      </el-collapse-item>

      <el-collapse-item name="lecture">
        <template slot="title">
          <span class="set_title">推荐讲座: </span>
          <span class="setting-item type"
                :type="settings.lecture.settingType">推荐方式: {{ settings.lecture.settingType | typeFmt }}</span>
          <span class="setting-item">数量限制: {{ settings.lecture.numLimit }}</span>
          <i class="el-icon-setting" @click="updateSetting('lecture','讲座')"></i>
        </template>
        <div>
          <div class="con_item thumb" :style="'backgroundImage: url('+settingItems.lecture.thumbnailPath+')'"></div>
          <div class="con_item content">
            <div class="title">{{ settingItems.lecture.title }}</div>
            <div class="sub_title">{{ settingItems.lecture.subTitle }}</div>
            <div>
              <el-button type="warning" plain>
                <router-link :to="'/lectureDetail?state=0&id='+settingItems.lecture.id">详情</router-link>
              </el-button>
            </div>
          </div>
        </div>
      </el-collapse-item>

      <el-collapse-item name="exam">
        <template slot="title">
          <span class="set_title">推荐测试: </span>
          <span class="setting-item type"
                :type="settings.exam.settingType">推荐方式: {{ settings.exam.settingType | typeFmt }}</span>
          <span class="setting-item">数量限制: {{ settings.exam.numLimit }}</span>
          <i class="el-icon-setting" @click="updateSetting('exam','心理测试')"></i>
        </template>
        <div>
          <div class="list-exam " v-for="(item,ind) in settingItems.exam" :key="ind"> <!--@click="toDetail(item.id)"-->
            <div :style="item.exhibitImg?'backgroundImage: url('+item.exhibitImg+')':''" class="listImg"></div>
            <div class="listRight">
              <h4>{{ item.title }}</h4>
              <p>{{ item.description }}</p>
              <div class="date">
                <span>￥<span>{{ item.price }}</span></span>
                <span>{{ item.testedCount }}人已测</span>
                <span>{{ item.msgCount }}人评论</span>
                <span>{{ item.exceptTime }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>


    <el-drawer :title="dialog_setting.title" :visible.sync="dialog_setting.show" :wrapperClosable="false"
               :show-close="false" size="700px" class="drawerCommon recommendDrawer" :close-on-press-escape="false">
      <el-form ref="form" :model="form" label-width="100px" class="maxHeight">
        <el-form-item label="推荐方式：">
          <el-radio-group v-model="form.type">
            <el-radio label="1">最热</el-radio>
            <el-radio label="2">最新</el-radio>
            <el-radio label="3" @change="showList">自定义</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="transfer_div" v-if="form.type==3">
          <template v-if="form.code=='news'">
            <el-transfer filterable filter-placeholder="请输入新闻标题" :titles="['所有新闻','已选新闻']" v-model="selectedList.news"
                         :data="optionList.news"></el-transfer>
          </template>
          <template v-if="form.code=='doctor'">
            <el-transfer filterable filter-placeholder="请输入医生姓名" :titles="['所有医生','已选医生']" v-model="selectedList.doctor"
                         :data="optionList.doctor"></el-transfer>
          </template>
          <template v-if="form.code=='research'">
            <el-transfer filterable filter-placeholder="请输入研究标题" :titles="['所有研究文章','已选研究文章']"
                         v-model="selectedList.research" :data="optionList.research"></el-transfer>
          </template>
          <template v-if="form.code=='drug'">
            <el-transfer filterable filter-placeholder="请输入药品名称" :titles="['所有药物','已选药物']" v-model="selectedList.drug"
                         :data="optionList.drug"></el-transfer>
          </template>
          <template v-if="form.code=='consultation'">
            <el-transfer filterable filter-placeholder="请输入会诊标题" :titles="['所有会诊','已选会诊']"
                         v-model="selectedList.consultation" :data="optionList.consultation"></el-transfer>
          </template>
          <template v-if="form.code=='lecture'">
            <el-transfer filterable filter-placeholder="请输入讲座名称" :titles="['所有讲座','已选讲座']"
                         v-model="selectedList.lecture" :data="optionList.lecture"></el-transfer>
          </template>
          <template v-if="form.code=='exam'">
            <el-transfer filterable filter-placeholder="请输入测试名称" :titles="['所有测试','已选测试']" v-model="selectedList.exam"
                         :data="optionList.exam"></el-transfer>
          </template>
        </div>
      </el-form>
      <div class="footer">
        <el-button size="small" @click="hideDialog">取消
        </el-button>
        <el-button size="small" type="primary"
                   @click="saveSetting" :loading="saveBtnLoading">保存
        </el-button>
      </div>
    </el-drawer>


  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "recommendSetting",
  data() {
    return {
      saveBtnLoading: false,
      settings: {
        news: {},
        doctor: {},
        research: {},
        drug: {},
        consultation: {},
        lecture: {},
        exam: []
      },
      settingItems: {
        news: [],
        doctor: [],
        research: [],
        drug: [],
        consultation: {},
        lecture: {},
        exam: []
      },

      dialog_setting: {
        show: false,
        type: '',
        title: "设置",
      },
      form: {
        code: '',
        type: '1',
        list: '',
      },

      optionList: {
        news: [],
        doctor: [],
        research: [],
        drug: [],
        consultation: [],
        lecture: [],
        exam: []
      },
      selectedList: {
        news: [],
        doctor: [],
        research: [],
        drug: [],
        consultation: [],
        lecture: [],
        exam: []
      },
    }
  },
  mounted() {
    this.$ajax.get(base.manager_api.recommend.settings).then((res) => {
      if (res.data.status === 'success') {
        $(res.data.list).each((i, o) => {
          o.settingType = o.settingType + "";
          this.settings[o.code] = o;
        });
      }
    });
  },
  methods: {
    handleChangeEvent(item) {
      if (item) {
        if (Array.isArray(this.settingItems[item])) {
          let length = this.settingItems[item].length;
          if (length > 0) { // 减少重复加载
            return;
          }
        } else if (this.settingItems[item].id) {
          return;
        }

        let url = base.api.recommend[item];
        switch (item) {
          case 'news':
          case 'doctor':
          case 'research':
          case 'drug':
          case 'exam':
            this.$ajax.get(base.api.recommend[item]).then((res) => {
              if (res.data.status === 'success') {
                this.settingItems[item] = res.data.list;
              }
            });
            break;
          case 'consultation':
          case 'lecture':
            this.$ajax.get(base.api.recommend[item]).then((res) => {
              if (res.data.status === 'success') {
                this.settingItems[item] = res.data.data;
              }
            });
            break;
        }
      }
    },
    updateSetting(typeCode, title) {
      this.dialog_setting.type = typeCode;
      this.dialog_setting.title = title + '设置';
      this.form.code = this.settings[typeCode].code;
      this.form.type = this.settings[typeCode].settingType;

      if (this.form.type == 3) {
        this.showList();
      }

      this.dialog_setting.show = true;
    },
    hideDialog() {
      this.form.list = [];
      this.dialog_setting.show = false;
    },
    saveSetting() {
      let code = this.form.code;
      let type = this.form.type;
      let data = {
        code: code,
        settingType: type
      };
      if (type == 3) {
        if (this.selectedList[code].length > this.settings[code].numLimit) {
          this.$message.warning("设置最大数量为: " + this.settings[code].numLimit);
          return;
        }
        data['items'] = $.map(this.selectedList[code], (o, i) => {
          return {recommendId: o};
        });
      }

      this.saveBtnLoading = true;
      this.$ajax.post(base.manager_api.recommend.update, data).then(res => {
        if (res.data.status === 'success') {
          this.$message.success(res.data.message);
          setTimeout('location.reload()', 2000);
        } else {
          this.$message.error(res.data.message);
          this.saveBtnLoading = false;
        }
      }).catch((err) => {
        console.error(err);
        this.$message.error('操作失败');
      });
    },
    showList() {
      let url, labelField, spare;
      let code = this.form.code;
      // console.log("自定义加载数据: " + code);
      switch (code) {
        case "news":
          labelField = "title";
          spare = "summary";
          url = base.api.article.information.baseAll;
          break;
        case "doctor":
          labelField = "fullName";
          spare = "enName";
          url = base.api.doctor.teamBaseAll;
          break;
        case "research":
          labelField = "title";
          spare = "summary";
          url = base.api.article.research.baseAll;
          break;
        case "drug":
          labelField = "cnName";
          spare = "enName";
          url = base.api.drug.baseAll;
          break;
        case "consultation":
          labelField = "title";
          spare = "subTitle";
          url = base.api.expert.consultation.baseAll;
          break;
        case "lecture":
          labelField = "title";
          spare = "subTitle";
          url = base.api.expert.lecture.baseAll;
          break;
        case 'exam':
          labelField = 'title';
          spare = "subTitle";
          url = base.api.exam.baseAll;
      }
      this.$ajax.get(url).then((res) => {
        if (res.data.status === 'success') {
          this.optionList[code] = $.map(res.data.list, (o, i) => {
            let labelText = o[labelField];
            if (!labelText) {
              labelText = o[spare]; //对应字段为空时使用备选字段
            }
            return {
              key: o.id,
              label: labelText
            };
          });
        }
      })
    },
  },
  filters: {
    typeFmt(type) {
      switch (type) {
        case '1':
          return "最热";
        case '2':
          return "最新";
        case '3':
          return "设置";
        default:
          return "-";
      }
    },
    indicationFmt(indications) {
      if (indications) {
        let skills = [];
        $(indications).each((i, o) => {
          if (o && o.cnName) {
            skills.push(o.cnName);
          }
        });
        return skills.join("、");
      }
    },
  }
}
</script>


<style scoped lang="scss">
@import '../../../assets/css/admin.scss';
.set_title {
  font-size: 20px;
  margin-right: 20px;
}

.setting-item {
  line-height: 54px;
  display: inline-block;
  height: 48px;
  margin-left: 20px;
  width: 120px;
  background-repeat: no-repeat;
  background-position: right;
}

.setting-item[type='1'] {
  background-image: url("../../../../public/static/imgs/hot.png");
  background-size: 24px;
  background-position-y: 12px;
}

.setting-item[type='2'] {
  background-image: url("../../../../public/static/imgs/new.png");
  background-size: 30px;
  background-position-y: 16px;
}

.setting-item[type='3'] {
  background-image: url("../../../../public/static/imgs/diy.png");
  background-size: 22px;
  background-position-y: 14px;
}


</style>

<style lang="css">



</style>